const translations = {
    eaVisionCreateConnectionFailure: 'Error creating EAVision connection. Please try again later.',
    eaVisionSyncFlightJobsFailure: 'Error syncing EAVision flights. Please try again later.',
    eaVisionSyncFlightJobsSuccess: 'EAVision flights synced successfully.'
};

export default translations;
